import { DateTime } from 'luxon';
import type { ISO8601, ISODate } from '@/iso8601';

export function parseISODate(date: ISODate): DateTime | null {
  try {
    const parsed = DateTime.fromISO(date);
    return parsed.isValid ? parsed : null;
  } catch {
    return null;
  }
}

export function parseISOTime(time: ISO8601, zone?: string): DateTime | null {
  try {
    const parsed = DateTime.fromISO(time, zone ? { zone } : undefined);
    return parsed.isValid ? parsed : null;
  } catch {
    return null;
  }
}

export function isHostValid(url: string): boolean {
  try {
    const { hostname } = new URL(url);

    if (hostname === 'peopleware.com') return true;

    return (
      hostname.endsWith('.peopleware.com') ||
      hostname.endsWith('.peopleware.local')
    );
  } catch {
    return false;
  }
}

export function getRedirectUrl(returnUrl: string | null): string {
  if (returnUrl && isHostValid(returnUrl)) {
    return returnUrl;
  }

  return '/entrypoint';
}

export function searchParamsToString(
  searchParams: Record<string, string | string[] | undefined>,
): string {
  const params = new URLSearchParams();

  for (const [key, value] of Object.entries(searchParams)) {
    for (const entry of [value].flat()) {
      if (entry !== undefined) params.append(key, entry);
    }
  }

  return params.toString();
}
